export default __webpack_public_path__ + "static/media/8.dcf4ac37.jpg";